module.exports = __webpack_public_path__ + "static/img/defaultBg.9b10656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defaultBg.png
// module id = Nro5
// module chunks = 2